<template>
  <div class="footer">
    <p>
      联系电话：王老师 15853217870
      <span>|</span>
      技术支持：唐工 17706521231
      <span>|</span>
      服务电话：朱老师 15966818040
      <span>|</span>
      @山东依智科技产业开发集团有限公司 @2023 鲁ICP备2020045516号-3
    </p>
    <div style="height: 1px; background-color: #46494d; margin: 15px 0 10px"></div>
    <p>Copyright © 2003-2023 zhihuijiaoxue. All rights reserved.</p>
  </div>
</template>

<script>
export default {
  name: "FooterVue",
};
</script>

<style lang="less" scoped >
.footer {
  padding: 15px 0;
  height: 100%;
  background-color: #1e2023;
  text-align: center;
  color: #fff;
  color: #bcbec2;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  p {
    margin-top: 5px;
    span {
      margin: 0 10px;
    }
  }
}
</style>